import React from 'react';
import { FormattedMessage } from 'react-intl';

import get from 'lodash/get';

import aboutAwards from 'assets/about-awards.png';
import aboutAwardsSvg from 'assets/aboutAwardsSvg.svg';
import aboutAwardsFr from 'assets/about-awards_fr.png';
import PageTitle from 'shared/PageTitle';
import Auth from 'shared/Auth';
import Text from 'ui/Text';

const AboutAwards = () => {
  const defaultLang = get(Auth.getLanguage(), 'local_locale');

  const indicators = {
    fr: aboutAwardsSvg,
    en: aboutAwardsSvg,
  };

  return (
    <div id="about">
      <PageTitle title="About the Awards" />
      <div>
        <div className="inner-content about-explainer bg-light-grey">
          <Text type="heading-semi-bold" modifiers="text-center title heavy">
            <FormattedMessage
              id="About.AboutTheAward"
              defaultMessage="Welcome to the African CSO platform!"
            />
            <span className="fake-border fake-border__underline center-block" />
          </Text>
          <div className="row no-margin">
            <div className="col-sm-12 col-md-9 col-lg-9 center-block">
              <Text type="explainer" modifiers="explanations-area plain-message text-center">
                <FormattedMessage
                  id="AboutAwards.Explanation.First"
                  defaultMessage="
                 The important contributions that African CSOs make to the wellbeing of the continent remain
largely invisible, even to those who benefit most from CSO actions. This invisibility undermines the
sector’s legitimacy, credibility and its ability to attract potential funders and other allies. Invisibility
also helps to perpetuate a prevailing perception of African CSOs as weak and poorly governed, and
thus “risky”. To change this narrative and enable African CSOs to secure and sustain the support
they need, and deserve, EPIC-Africa has developed a CSO assessment tool that enables CSOs to
engage in a “moment of reflection” on their organizational capacity, the engine that drives success
and the impact they seek.
                  "
                />
                <span className="semi-bold emphasis">
                  <FormattedMessage
                    id="AboutAwards.Explanation.Second"
                    defaultMessage="
                  The assessment tool covers eight key areas of organizational capacity: Strategic Ability and
Adaptability, Leadership and Governance, Financial Health and Management, Human Resources
and Staff Development, Operations, Communications, Partnerships and Alliances, and Monitoring
and Evaluation.
                  "
                  />
                </span>
              </Text>
            </div>
          </div>
          <div className="text-center">
            <img className="explainer-pic" src={get(indicators, defaultLang)} alt="About Awards" />
          </div>
          <div className="col-sm-12 col-md-9 col-lg-9 center-block">
            <Text type="explainer" modifiers="explanations-area plain-message text-center">
              <FormattedMessage
                id="AboutAwards.Explanation.Fifth"
                defaultMessage="
                  EPIC-Africa sees strong organizational capacity not as separate and secondary to program
                  development, but as integral to programming and believes that it is a strategic investment that
                  drives program quality, implementation, and longevity. Our goal is to elevate organizational
                  capacity and highlight its importance to achieve program impact. The indicators that we have
                  chosen are embedded in a capacity building framework to help you identify and prioritize
                  actions to make your organizations stronger.
                  "
              />
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutAwards;



// WEBPACK FOOTER //
// ./src/components/HomePage/AboutAwards.js